module.exports = __webpack_public_path__ + "img/pen-alt-solid.2cc83994.svg";